module.exports = __webpack_public_path__ + "img/版图文件.384b4595.svg";